import { render, staticRenderFns } from "./formListaEmbarquePallet.vue?vue&type=template&id=4fdf42d0"
import script from "./formListaEmbarquePallet.vue?vue&type=script&lang=js"
export * from "./formListaEmbarquePallet.vue?vue&type=script&lang=js"
import style0 from "./formListaEmbarquePallet.vue?vue&type=style&index=0&id=4fdf42d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports